import { Box, Grid, Theme, Typography } from "@mui/material";
import { ViewProfileProps } from "../types";
import { KeyValue } from "../../ApplicationDetails/personalDetails";

export default function RMDetails({ overviewData }: { overviewData: Partial<ViewProfileProps> }): JSX.Element {
    const firstName = overviewData.rm?.user.firstName;
    const phone = overviewData.rm?.user?.phone;
    const email = overviewData?.rm?.user?.email;
    return (
        <>
            <Box
                sx={(theme: Theme) => ({
                    bgcolor: theme.palette.customColors.infoCard,
                    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                    borderRadius: '10px',
                    border: `1px solid ${theme.palette.grey[100]}`,
                    padding: '25px',
                    mb: '40px'

                })}
            >
                <Box>
                    <Grid container >
                        <Grid item xs={12} >
                            <Typography  variant="h2" sx={(theme: Theme) => ({ fontSize: 18, fontWeight: 700, color: theme.palette.primary[500], mb: '25px' })}>
                                IA Details
                            </Typography>

                        </Grid>
                        <Grid
                            item
                            container
                            rowSpacing={3}
                            columnSpacing={5.5}
                            direction="row"

                        >
                            <KeyValue title={"IA's Name"} description={firstName} />
                            <KeyValue title={"IA's Email Address"} description={email} />
                            <KeyValue title={"IA's Mobile Number"} description={`+91 ${phone}`} />

                        </Grid>

                    </Grid>
                </Box>
            </Box >
        </>
    )
}